import { FC } from 'react';
import { DiffBase, DiffBaseProps, type LabelTransformer } from '../diff-base';

const InternationalCertificatesDiff: FC<Omit<DiffBaseProps, 'labelTransformer' | 'fieldName'>> = (props) => {
  const labelTransformer: LabelTransformer<'internationalCertificates'> = (data) => data.translation;
  return <DiffBase multiple fieldName="internationalCertificates" labelTransformer={labelTransformer} {...props} />;
};

export default InternationalCertificatesDiff;
